
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/automotive-software/car-wash-software",
      function () {
        return require("private-next-pages/automotive-software/car-wash-software.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/automotive-software/car-wash-software"])
      });
    }
  